import styled from 'styled-components';

import {useParams} from "react-router-dom";
import useFeedback from "../../../utils/use_feedback";
import {WhiteMain} from "../../../components/main";
import {FixedTopBar} from "../../../components/top_bar";
import {useSaveClicked} from "../../../store";
import React, {useEffect, useState} from "react";
import {useFullModeratorsList} from "../../../api/moderation";
import useModal from "../../../modals";
import Sheet from "../../../components/bottom-sheet/sheet";
import EditModeratorSheet from "../../../components/bottom-sheet/mod/edit_moderator";
import {themecolors} from "../../../utils/themecolors";
import AddModeratorSheet from "../../../components/bottom-sheet/mod/add_moderator";

const Item = styled.div``;
const Permissions = styled.span``;

const Moderator = styled(({className, moderator, onClick}) => {
    const permissionText = moderator.permissions.all_permissions ? 'All' : 'Mixed';
    const handleClick = moderator.can_edit && onClick;
    return (
        <Item className={className} onClick={handleClick}>
            {moderator.author}
            <Permissions>{permissionText} Permissions</Permissions>
        </Item>
    );
})`
  cursor: pointer;
  display: flex;
  flex-grow: 1;
  color: ${({theme}) => theme.color.name === 'dark' ? theme.white_0 : 'inherit'};
  padding: 12px 24px;

  ${Permissions} {
    font-weight: 400;
    font-size: 14px;
    margin-left: auto;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }
`;

const ModeratorsCommunitySettings = styled(({className}) => {
    const {community} = useParams();
    const {error, feedbackCh} = useFeedback();
    const [time, setTime] = useState(Date.now());
    const fullModerators = useFullModeratorsList(feedbackCh, community, time);
    const moderators = fullModerators?.moderators;

    const saveClicked = useSaveClicked();
    const modal = useModal();
    const [addModeratorOpen, setAddModeratorOpen] = useState(false);
    useEffect(() => {
        (async () => {
            if (saveClicked) {
                setAddModeratorOpen(true);
            }
        })().then(() => {
        }, () => {
        });
    }, [saveClicked]);

    const [editModeratorOpen, setEditModeratorOpen] = useState(false);
    const [moderator, setModerator] = useState(false);
    const handleEdit = (editModerator) => {
        setModerator(editModerator);
        setEditModeratorOpen(true);
    };

    const handleClose = () => {
        setEditModeratorOpen(false);
        setAddModeratorOpen(false);
        setTime(Date.now());
    };

    return (
        <>
            <FixedTopBar back title="Community Moderators" border save={'Add'}/>
            <WhiteMain className={className}>
                {moderators && moderators?.map((moderator, i) => (
                    <Moderator key={i} moderator={moderator} onClick={() => handleEdit(moderator)}/>
                ))}
            </WhiteMain>
            {editModeratorOpen && <Sheet onClose={() => handleClose() } padding={"header"}><EditModeratorSheet community={community} moderator={moderator} onClose={() => handleClose() } /></Sheet>}
            {addModeratorOpen && <Sheet onClose={() => handleClose() } padding={"header"}><AddModeratorSheet community={community} onClose={() => handleClose() } /></Sheet>}
        </>
    );
})`
  ${Item} {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : theme.light_high_impact_text};
    font-weight: 600;
    padding: 12px 24px;
    font-size: 16px;
    background-color: ${({theme}) => theme.color.name === 'dark' ? 'transparent' : '#fff'};
  }

  ${Permissions} {
    margin-left: auto;
  }
`;

export default ModeratorsCommunitySettings;
